import React, { useEffect, useState } from 'react';
import Select from "react-select";
import { getSelectList } from '../../../config/utils';
import { useSelector } from 'react-redux';
import { fetchCompanyFilters, getFilterSellers } from '../../../store/actions/rateCard';
import { getAllCarrierServices, getAllCarrierServicesList, getAllSellersList } from "../../../store/actions";
import _ from 'lodash';
import DatePicker from "react-datepicker";
import DatePickerComponent from '../../common/DatePickerComponent';
import { getAllLedgerStatus, getAllLedgerTransactionMode, GetAllLedgerTransactionType } from '../../../store/actions/accounts.action';
import { getAllTaskPriority, getAllTaskStatus, getAllTaskType } from '../../../store/actions/picker.action';
import { getAllCarrierList, getPackagetypeList, getSourceListList, getProductWarehouseList } from '../../../store/actions/incoming';
import { requestShipmentStatus } from '../../../constant';
import PropTypes from "prop-types";

/* istanbul ignore next */
const ProductListingFilter = (props) => {
    const { showFilter, handleReset, fetchProductList, dispatch, filterData, setfilterData, sellerList, setSellerList, allSellers, setAllSellers, handleDateFieldChange, type, taskCategory, dateRange, handleDateRangeChange } = props;
    const [companyList, setCompanyList] = useState([]);
    const [transactionModeList, setTransactionModeList] = useState([]);
    const [transactionList, setTransactionList] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const { filterCompanies, filterAllSellers } = useSelector((state) => state.RateCardReducer);
    const { transactionsModeList, transactionTypeList, ledgerStatusList } = useSelector((state) => state.accountingReducer);
    const { allTaskStatusList, allTaskPriorityList, allTaskTypeList } = useSelector((state) => state.pickerReducer);
    const carrierServices = useSelector((state) => state.shipment.carrierServices);
    const carriers = useSelector((state) => state.shipment.carriers);
    const { allCarriersList, sourcesList: incomingSourcesList, PackageTypeList } = useSelector((state) => state.IncomingReducer || {});
    const productWarehouseListData = useSelector((state) => state?.IncomingProductReducer?.productWarehouseList);
    const [taskStatusList, setTaskStatusList] = useState([]);
    const [taskPriorityIdList, setTaskPriorityList] = useState([]);
    const [taskTypeIdList, setTaskTypeList] = useState([]);
    const [allCarrierServices, setAllCarrierServices] = useState([]);
    const [carrierIdList, setCarrierIdList] = useState([]);
    // Task-tab lookup options (sources, package types, carriers, warehouses)
    const [taskCarrierList, setTaskCarrierList] = useState([]);
    const [taskSourceList, setTaskSourceList] = useState([]);
    const [taskPackageTypeList, setTaskPackageTypeList] = useState([]);
    const [taskWarehouseList, setTaskWarehouseList] = useState([]);

    useEffect(() => {
        if (type === "task") {
            if (allTaskStatusList.length > 0) {
                setTaskStatusList(getSelectList(allTaskStatusList, "id", "statusName"));
            };

            if (allTaskPriorityList?.length > 0) {
                setTaskPriorityList(getSelectList(allTaskPriorityList, "id", "priorityName"));
            }

            if (allTaskTypeList?.length > 0) {
                setTaskTypeList(getSelectList(allTaskTypeList, "id", "typeName"));
            }
        }
    }, [allTaskStatusList, allTaskPriorityList, allTaskTypeList]);

    useEffect(() => {
        if (carriers?.length) {
            setCarrierIdList(getSelectList(carriers, 'id', 'carrierCompanyName'));
        }
    }, [carriers]);

    useEffect(() => {
        if (carrierServices?.length) {
            setAllCarrierServices(getSelectList(carrierServices, 'id', 'serviceName'));
        }
    }, [carrierServices]);

    // Task-tab lookup -> select options
    useEffect(() => {
        if (type === "task" && allCarriersList?.length) {
            setTaskCarrierList(getSelectList(allCarriersList, 'id', 'carrierCompanyName'));
        }
    }, [type, allCarriersList]);

    useEffect(() => {
        if (type === "task" && incomingSourcesList?.length) {
            setTaskSourceList(getSelectList(incomingSourcesList, 'id', 'source'));
        }
    }, [type, incomingSourcesList]);

    useEffect(() => {
        if (type === "task" && PackageTypeList?.length) {
            setTaskPackageTypeList(getSelectList(PackageTypeList, 'id', 'packageType'));
        }
    }, [type, PackageTypeList]);

    useEffect(() => {
        if (type === "task" && productWarehouseListData?.length) {
            setTaskWarehouseList(getSelectList(productWarehouseListData, 'id', 'location'));
        }
    }, [type, productWarehouseListData]);

    useEffect(() => {
        let companyList = filterCompanies?.Entity?.listCompanyMasterOrdersEntity || [];
        let sellerList = filterAllSellers?.EntityList || [];
        if (companyList.length) {
            setCompanyList(getSelectList(filterCompanies?.Entity?.listCompanyMasterOrdersEntity, 'Id', 'name'));
        }
        if (sellerList.length) {
            setAllSellers(getSelectList(sellerList, 'id', 'sellerName'));
            setSellerList(getSelectList(sellerList, 'id', 'sellerName'));
        }
    }, [filterCompanies, filterAllSellers]);

    useEffect(() => {
        if (type === "ledger" && transactionTypeList.length === 0) {
            dispatch(GetAllLedgerTransactionType());
        } else if (transactionTypeList.length > 0) {
            setTransactionList(getSelectList(transactionTypeList, "id", "transactionType"));
        }
    }, [type, transactionTypeList]);

    useEffect(() => {
        if (type === "ledger" && transactionsModeList.length === 0) {
            dispatch(getAllLedgerTransactionMode());
        } else if (transactionsModeList.length > 0) {
            setTransactionModeList(getSelectList(transactionsModeList, "id", "transactionMode"));
        }
    }, [type, transactionsModeList]);

    useEffect(() => {
        if (type === "ledger" && ledgerStatusList.length === 0) {
            dispatch(getAllLedgerStatus());
        } else if (ledgerStatusList.length > 0) {
            setStatusList(getSelectList(ledgerStatusList, "id", "statusName"));
        }
    }, [type, ledgerStatusList]);

    const handleMultiSelect = (value, fieldName) => {
        setfilterData({
            ...filterData,
            [fieldName]: value
        });
        if (fieldName === "companyIdList") {
            let companyData = _.map(value, "Id");
            fetchSellers(companyData);
            if (filterData?.sellerIdList?.length) {
                const filteredSellers = filterData.sellerIdList.filter(seller =>
                    companyData.includes(parseInt(seller.companyIds)) // NOSONAR
                );
                setfilterData({ ...filterData, sellerIdList: filteredSellers, companyIdList: value })
            }
        }
    }

    const fetchSellers = async (companyList) => {
        if (companyList.length === 0) {
            setSellerList(allSellers);
            return;
        }
        let data = {
            companyIds: companyList,
        };
        try {
            let res = await getAllSellersList(data);
            if (res?.data?.Status === 200) {
                let dataList = res?.data?.Entity?.listSellerMasterOrdersEntity.map(
                    (item) => {
                        return {
                            ...item,
                            label: item.sellerAndCompany,
                            value: item.id,
                        };
                    }
                );
                setSellerList(dataList);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const dispatchTaskLookups = () => {
        const taskLookups = [
            { list: allTaskStatusList, action: getAllTaskStatus },
            { list: allTaskPriorityList, action: getAllTaskPriority },
            { list: allTaskTypeList, action: getAllTaskType },
            { list: allCarriersList, action: getAllCarrierList },
            { list: incomingSourcesList, action: getSourceListList },
            { list: PackageTypeList, action: getPackagetypeList },
            { list: productWarehouseListData, action: getProductWarehouseList },
        ];
        taskLookups.forEach(({ list, action }) => {
            if (!list?.length) dispatch(action());
        });
    };

    const dispatchRefundsLookups = () => {
        if (!carrierServices.length) {
            dispatch(getAllCarrierServices({}));
            dispatch(getAllCarrierServicesList());
        }
    };

    useEffect(() => {
        let data = {
            pageIndex: 1,
            pageSize: 10,
            sortColumn: 'name',
            sortOrder: 'ascending'
        };
        let sellerData = {
            "pageIndex": 1,
            "pageSize": 10,
            "sortColumn": "name",
            "sortOrder": "ASCENDING",
            "companyIdList": [0],
            screenType: 2,
        };
        dispatch(fetchCompanyFilters(data));
        dispatch(getFilterSellers(sellerData));
        if (type === "task") {
            dispatchTaskLookups();
        }
        if (type === "refunds") {
            dispatchRefundsLookups();
        }
    }, []);

    return (
        <div className={showFilter ? 'filterWrapperGradient filterContainer filterContainerZIndex show historyFilter zIndex2 pt-2' : 'filterContainer historyFilter'}>
            <div className='decorativeElem'></div>
            <div className='row mb-2'>
                <div className='col-lg-3 col-sm-12 mobMb-10'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='labelHead'>Company</div>
                        </div>
                        <div className='col-12 fontFix'>
                            <Select
                                isMulti
                                closeMenuOnSelect={false}
                                options={companyList}
                                classNamePrefix="list"
                                id='companyIdList'
                                name="companyIdList"
                                value={filterData?.companyIdList}
                                onChange={(value) =>
                                    handleMultiSelect(value, "companyIdList")
                                }
                            />
                        </div>
                    </div>
                </div>
                <div className='col-lg-3 col-sm-12 mobMb-10'>
                    <div className='row'>
                        <div className='col-12'>
                            <div className='labelHead'>Seller</div>
                        </div>
                        <div className='col-12 fontFix'>
                            <Select
                                isMulti
                                closeMenuOnSelect={false}
                                options={sellerList}
                                classNamePrefix="list"
                                id='sellerIdList'
                                name="sellerIdList"
                                value={filterData?.sellerIdList}
                                onChange={(value) =>
                                    handleMultiSelect(value, "sellerIdList")
                                }
                            />
                        </div>
                    </div>
                </div>
                {((type && type === "ledger") || type === "sellerLedger") && (
                    <>
                        <div className='col-lg-3 col-sm-12 mobMb-10'>
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='labelHead'>From:</div>
                                </div>
                                <div className='col-12 fontFix'>
                                    <DatePickerComponent
                                        dateField={filterData.startDate}
                                        handleDateChange={(date) => handleDateFieldChange(date, 'startDate')}
                                        fieldName="startDate"
                                        dateFormat="MM-dd-yyyy"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 col-sm-12 mobMb-10 '>
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='labelHead'>To:</div>
                                </div>
                                <div className='col-12 fontFix'>
                                    <DatePickerComponent
                                        dateField={filterData.endDate}
                                        handleDateChange={(date) => handleDateFieldChange(date, 'endDate')}
                                        fieldName="endDate"
                                        dateFormat="MM-dd-yyyy"
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                )}
                {type && type === "ledger" && (
                    <>
                        <div className='col-lg-3 col-sm-12 mobMb-10 mt-4'>
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='labelHead'>Transaction Mode</div>
                                </div>
                                <div className='col-12 fontFix'>
                                    <Select
                                        isMulti
                                        closeMenuOnSelect={false}
                                        options={transactionModeList}
                                        classNamePrefix="list"
                                        id='transactionModeIdList'
                                        name="transactionModeIdList"
                                        value={filterData?.transactionModeIdList}
                                        onChange={(value) =>
                                            handleMultiSelect(value, "transactionModeIdList")
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 col-sm-12 mobMb-10 mt-4'>
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='labelHead'>Transaction Type</div>
                                </div>
                                <div className='col-12 fontFix'>
                                    <Select
                                        isMulti
                                        closeMenuOnSelect={false}
                                        options={transactionList}
                                        classNamePrefix="list"
                                        id='transactionTypeIdList'
                                        name="transactionTypeIdList"
                                        value={filterData?.transactionTypeIdList}
                                        onChange={(value) =>
                                            handleMultiSelect(value, "transactionTypeIdList")
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 col-sm-12 mobMb-10 mt-4'>
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='labelHead'>Status</div>
                                </div>
                                <div className='col-12 fontFix'>
                                    <Select
                                        isMulti
                                        closeMenuOnSelect={false}
                                        options={statusList}
                                        classNamePrefix="list"
                                        id='statusIdList'
                                        name="statusIdList"
                                        value={filterData?.statusIdList}
                                        onChange={(value) =>
                                            handleMultiSelect(value, "statusIdList")
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {type && type === "task" && (
                    <>
                        {/* Date Range — moved into filter row per AC2 */}
                        {handleDateRangeChange && (
                            <div className='col-lg-3 col-sm-12 mobMb-10'>
                                <div className='row'>
                                    <div className='col-12'>
                                        <div className='labelHead'>Date Range</div>
                                    </div>
                                    <div className='col-12 fontFix'>
                                        <DatePicker
                                            className="date-picker form-control pr-4"
                                            selectsRange={true}
                                            startDate={dateRange?.[0] || null}
                                            endDate={dateRange?.[1] || null}
                                            onChange={(update) => handleDateRangeChange(update)}
                                            dateFormat="MM-dd-yyyy"
                                            isClearable={true}
                                            iconPosition="right"
                                            placeholderText="Select Date Range"
                                            maxDate={new Date()}
                                        />
                                    </div>
                                </div>
                            </div>
                        )}
                        <div className='col-lg-3 col-sm-12 mobMb-10'>
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='labelHead'>Status</div>
                                </div>
                                <div className='col-12 fontFix'>
                                    <Select
                                        isMulti
                                        closeMenuOnSelect={false}
                                        options={taskStatusList}
                                        classNamePrefix="list"
                                        id='taskStatusList'
                                        name="taskStatusList"
                                        value={filterData?.taskStatusList}
                                        onChange={(value) =>
                                            handleMultiSelect(value, "taskStatusList")
                                        }
                                    />
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-3 col-sm-12 mobMb-10'>
                            <div className='row mb-2'>
                                <div className='col-12'>
                                    <div className='labelHead'>Priority</div>
                                </div>
                                <div className='col-12 fontFix'>
                                    <Select
                                        isMulti
                                        closeMenuOnSelect={false}
                                        options={taskPriorityIdList}
                                        classNamePrefix="list"
                                        id='taskPriorityIdList'
                                        name="taskPriorityIdList"
                                        value={filterData?.taskPriorityIdList}
                                        onChange={(value) =>
                                            handleMultiSelect(value, "taskPriorityIdList")
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                        <div className='col-lg-3 col-sm-12 mobMb-10'>
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='labelHead'>Type</div>
                                </div>
                                <div className='col-12 fontFix'>
                                    <Select
                                        isMulti
                                        closeMenuOnSelect={false}
                                        options={taskTypeIdList}
                                        classNamePrefix="list"
                                        id='taskTypeIdList'
                                        name="taskTypeIdList"
                                        value={filterData?.taskTypeIdList}
                                        onChange={(value) =>
                                            handleMultiSelect(value, "taskTypeIdList")
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                        {/* Shared: Tracking No + SKU (visible on Return tabs) */}
                        {(taskCategory === 'ReturnPackage' || taskCategory === 'ReturnProduct') && (
                            <>
                                <div className='col-lg-3 col-sm-12 mobMb-10'>
                                    <div className='row'>
                                        <div className='col-12'>
                                            <div className='labelHead'>Tracking No.</div>
                                        </div>
                                        <div className='col-12 fontFix'>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="trackingNumber"
                                                name="trackingNumber"
                                                placeholder="e.g. 1Z999AA10123456784"
                                                value={filterData?.trackingNumber || ''}
                                                onChange={(e) => handleMultiSelect(e.target.value, "trackingNumber")}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-3 col-sm-12 mobMb-10'>
                                    <div className='row'>
                                        <div className='col-12'>
                                            <div className='labelHead'>SKU</div>
                                        </div>
                                        <div className='col-12 fontFix'>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="productSku"
                                                name="productSku"
                                                placeholder="e.g. SKU-0042"
                                                value={filterData?.productSku || ''}
                                                onChange={(e) => handleMultiSelect(e.target.value, "productSku")}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                        {/* Return Package tab only: Package Type / Source / Carrier */}
                        {taskCategory === 'ReturnPackage' && (
                            <>
                                <div className='col-lg-3 col-sm-12 mobMb-10'>
                                    <div className='row'>
                                        <div className='col-12'>
                                            <div className='labelHead'>Package Type</div>
                                        </div>
                                        <div className='col-12 fontFix'>
                                            <Select
                                                isMulti
                                                closeMenuOnSelect={false}
                                                options={taskPackageTypeList}
                                                classNamePrefix="list"
                                                id='packageTypeIdList'
                                                name="packageTypeIdList"
                                                value={filterData?.packageTypeIdList}
                                                onChange={(value) => handleMultiSelect(value, "packageTypeIdList")}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-3 col-sm-12 mobMb-10'>
                                    <div className='row'>
                                        <div className='col-12'>
                                            <div className='labelHead'>Source</div>
                                        </div>
                                        <div className='col-12 fontFix'>
                                            <Select
                                                isMulti
                                                closeMenuOnSelect={false}
                                                options={taskSourceList}
                                                classNamePrefix="list"
                                                id='sourceIdList'
                                                name="sourceIdList"
                                                value={filterData?.sourceIdList}
                                                onChange={(value) => handleMultiSelect(value, "sourceIdList")}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-3 col-sm-12 mobMb-10'>
                                    <div className='row'>
                                        <div className='col-12'>
                                            <div className='labelHead'>Carrier</div>
                                        </div>
                                        <div className='col-12 fontFix'>
                                            <Select
                                                isMulti
                                                closeMenuOnSelect={false}
                                                options={taskCarrierList}
                                                classNamePrefix="list"
                                                id='carrierIdList'
                                                name="carrierIdList"
                                                value={filterData?.carrierIdList}
                                                onChange={(value) => handleMultiSelect(value, "carrierIdList")}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                        {/* Return Product tab only: RMA / Seller Product Id / Return Product Type / Warehouse */}
                        {taskCategory === 'ReturnProduct' && (
                            <>
                                <div className='col-lg-3 col-sm-12 mobMb-10'>
                                    <div className='row'>
                                        <div className='col-12'>
                                            <div className='labelHead'>RMA Code</div>
                                        </div>
                                        <div className='col-12 fontFix'>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="rmaCode"
                                                name="rmaCode"
                                                placeholder="e.g. RMA-1234"
                                                value={filterData?.rmaCode || ''}
                                                onChange={(e) => handleMultiSelect(e.target.value, "rmaCode")}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-3 col-sm-12 mobMb-10'>
                                    <div className='row'>
                                        <div className='col-12'>
                                            <div className='labelHead'>Seller Product Id</div>
                                        </div>
                                        <div className='col-12 fontFix'>
                                            <input
                                                type="text"
                                                className="form-control"
                                                id="sellerProductId"
                                                name="sellerProductId"
                                                placeholder="e.g. SPID-9001"
                                                value={filterData?.sellerProductId || ''}
                                                onChange={(e) => handleMultiSelect(e.target.value, "sellerProductId")}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-3 col-sm-12 mobMb-10'>
                                    <div className='row'>
                                        <div className='col-12'>
                                            <div className='labelHead'>Return Product Type</div>
                                        </div>
                                        <div className='col-12 fontFix'>
                                            <Select
                                                isMulti
                                                closeMenuOnSelect={false}
                                                options={[]}
                                                classNamePrefix="list"
                                                id='returnProductTypeIdList'
                                                name="returnProductTypeIdList"
                                                value={filterData?.returnProductTypeIdList}
                                                onChange={(value) => handleMultiSelect(value, "returnProductTypeIdList")}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-3 col-sm-12 mobMb-10'>
                                    <div className='row'>
                                        <div className='col-12'>
                                            <div className='labelHead'>Warehouse</div>
                                        </div>
                                        <div className='col-12 fontFix'>
                                            <Select
                                                isMulti
                                                closeMenuOnSelect={false}
                                                options={taskWarehouseList}
                                                classNamePrefix="list"
                                                id='warehouseIdList'
                                                name="warehouseIdList"
                                                value={filterData?.warehouseIdList}
                                                onChange={(value) => handleMultiSelect(value, "warehouseIdList")}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </>
                        )}
                    </>
                )}

                {type && type === "refunds" && (
                    <>
                        <div className='col-lg-3 col-sm-12 mobMb-10'>
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='labelHead'>Carrier</div>
                                </div>
                                <div className='col-12 fontFix'>
                                    <Select
                                        isMulti
                                        closeMenuOnSelect={false}
                                        options={carrierIdList}
                                        classNamePrefix="list"
                                        name="carrierIdList"
                                        value={filterData?.carrierIdList}
                                        onChange={(value) =>
                                            handleMultiSelect(value, "carrierIdList")
                                        }
                                    />
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-3 col-sm-12 mobMb-10'>
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='labelHead'>Service</div>
                                </div>
                                <div className='col-12 fontFix'>
                                    <Select
                                        isMulti
                                        closeMenuOnSelect={false}
                                        options={allCarrierServices}
                                        classNamePrefix="list"
                                        name="serviceIdList"
                                        value={filterData?.serviceIdList}
                                        onChange={(value) =>
                                            handleMultiSelect(value, "serviceIdList")
                                        }
                                    />
                                </div>
                            </div>
                        </div>

                        <div className='col-lg-3 col-sm-12 mt-2 mobMb-10'>
                            <div className='row'>
                                <div className='col-12'>
                                    <div className='labelHead'>Shipment Status</div>
                                </div>
                                <div className='col-12 fontFix'>
                                    <Select
                                        isMulti
                                        closeMenuOnSelect={false}
                                        options={requestShipmentStatus}
                                        classNamePrefix="list"
                                        name="statusIdList"
                                        value={filterData?.statusIdList}
                                        onChange={(value) =>
                                            handleMultiSelect(value, "statusIdList")
                                        }
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>
            <div className='alignRightRes mb-3 pr-0'>
                <button
                    className="btn cus-primary-transparent-btn top-btn clearFilterBtn"
                    onClick={(e) => handleReset(e, 'clear')}
                >
                    Clear Filter
                </button>
                <button
                    className="cus-seconday-bg-btn btn filterBtn"
                    onClick={() => fetchProductList(null)}
                >
                    Apply
                </button>
            </div>
        </div>
    );
}

ProductListingFilter.propTypes = {
    showFilter: PropTypes.bool,
    handleReset: PropTypes.func,
    fetchProductList: PropTypes.func,
    dispatch: PropTypes.func,
    filterData: PropTypes.object,
    setfilterData: PropTypes.func,
    sellerList: PropTypes.array,
    setSellerList: PropTypes.func,
    allSellers: PropTypes.array,
    setAllSellers: PropTypes.func,
    handleDateFieldChange: PropTypes.func,
    type: PropTypes.string,
    taskCategory: PropTypes.string,
    dateRange: PropTypes.array,
    handleDateRangeChange: PropTypes.func,
}

export default ProductListingFilter;